import httpClient from '../../global/httpClient';
import {
  GET_WRONG_QUESTION_LIST,
  GET_COLLECTION_QUESTION_LIST,
  GET_TYPE_QUESTION_LIST,
  GET_BOOK_TREE_QUESTION_LIST,
  GET_QUESTION_LIST,
  GET_COURSE_ANALYSIS,
  GET_PZ_FILTER_DATA,
  GET_AFTER_EXERCISE,
  POST_REMOVE_WRONG_LIST,
  getPzFilterDataType as api_getPzFilterDataType,
  getQuestionListType as api_getQuestionListType,
} from '../../constants/api';

export const getTypeList = courseId => httpClient.get(`${GET_TYPE_QUESTION_LIST}/${courseId}`);
export const getWrongList = courseId => httpClient.get(`${GET_WRONG_QUESTION_LIST}/${courseId}`);
export const getCollectionList = courseId =>
  httpClient.get(`${GET_COLLECTION_QUESTION_LIST}/${courseId}`);
export const getBookTreeList = courseId =>
  httpClient.get(`${GET_BOOK_TREE_QUESTION_LIST}/${courseId}`);
export const getQuestionList = payload => httpClient.post(GET_QUESTION_LIST, { ...payload });
export const getQuestionListType = (payload) => {
  const { type, ..._payload } = payload;
  return httpClient.post(api_getQuestionListType({ type }), _payload);
};
export const getCourseAnalysis = courseId => httpClient.get(`${GET_COURSE_ANALYSIS}/${courseId}`);
export const getPzFilterData = ({ courseId }) =>
  httpClient.get(`${GET_PZ_FILTER_DATA}/${courseId}`);
export const getPzFilterDataType = (payload) => httpClient.get(api_getPzFilterDataType(payload));
export const getAfterExercise = () => httpClient.get(`${GET_AFTER_EXERCISE}`);
export const removeWrongList = payload =>
  httpClient.post(POST_REMOVE_WRONG_LIST, { ...payload }, { ignore: true });
